import { onMount } from 'solid-js';
import { useAppData } from '~/components/AppData';
import { getPylonEmailHash } from '~/api/resources/pylon.ts';

declare global {
  interface Window {
    pylon?: {
      chat_settings: {
        app_id: string;
        email: string;
        name: string;
        avatar_url?: string;
        account_external_id?: string;
        email_hash?: string;
      };
    };
  }
}

export default function PylonWidget() {
  const appData = useAppData();

  onMount(async () => {
    if (appData.member && appData.workspace) {
      const fullName =
        [appData.member.firstName, appData.member.lastName]
          .filter(Boolean)
          .join(' ') || appData.member.email;

      const emailHash = await getPylonEmailHash();

      window.pylon = {
        chat_settings: {
          app_id: import.meta.env.VITE_PYLON_APP_ID,
          email: appData.member.email,
          name: fullName,
          account_external_id: appData.workspace.id,
          email_hash: emailHash
        }
      };
    }
  });

  return null;
}
